export type AdProviderConfig = {
  videoId?: string;
  partnerId?: number;
  uiConfId?: number;
  siteName?: { desktop?: string; mobile?: string };
  googleAnalyticsId?: string; // expected from backend per vendor
  gaMeasurementId?: string; // alias/fallback key name
};

export type AppConfigWithProviders = {
  adProvider: Record<string, AdProviderConfig>;
};

export function getAdConfig(
  appConfig: AppConfigWithProviders
): AdProviderConfig {
  const providers = appConfig?.adProvider || {};
  const defaultConfig = providers["default"] || {};

  const subdomain =
    typeof window !== "undefined"
      ? window.location.hostname.split(".")[0]
      : undefined;
  const queryParam =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("pid") || undefined
      : undefined;

  if (queryParam && providers[queryParam]) return providers[queryParam];
  if (subdomain && providers[subdomain]) return providers[subdomain];
  return defaultConfig;
}

export function getGaMeasurementId(
  adConfig: AdProviderConfig
): string | undefined {
  return adConfig.googleAnalyticsId || adConfig.gaMeasurementId;
}
